import "shared/styles/Home.css";

import React, {useState} from "react";
import {useParams} from "react-router-dom";

import {Category} from "features/validationRules/types";
import CategoryList from "../components/CategoryList";
import CategoryDetails from "../components/CategoryDetails";

const CategoriesPage = () => {
    const [activeCategory, setActiveCategory] = useState<Category|undefined>(undefined);
    const { cat_num } = useParams<{ cat_num: string|undefined }>();
    
    return (
        <div className="main-area">
            <div className="cat-list-sidebar"><CategoryList activeCategory={activeCategory} setActiveCategory={setActiveCategory} url_cat_num={cat_num}/></div>
            <div className="main">
                <CategoryDetails activeCategory={activeCategory} setActiveCategory={setActiveCategory} />
            </div>
        </div>
    );
};

export default CategoriesPage;